import { defineMessages } from "react-intl";
const messages = defineMessages({
    scanRequestPermissionLabel: {
        id: "app.users.createUser.scanRequest.label.text",
        defaultMessage: "Select scan request permission",
    },
    scanRequestPermissionOptionView: {
        id: "app.users.createUser.scanRequest.option.view.text",
        defaultMessage: "View Only",
    },
    scanRequestPermissionOptionEdit: {
        id: "app.users.createUser.scanRequest.option.edit.text",
        defaultMessage: "Can Edit",
    },
    scanRequestPermissionOptionCreate: {
        id: "app.users.createUser.scanRequest.option.create.text",
        defaultMessage: "Can Edit & Create",
    },
    scanRequestPermissionOptionNoAccess: {
        id: "app.users.createUser.scanRequest.option.deny.text",
        defaultMessage: "No Access",
    },
});
export default messages;
